import React, {useState, useRef, useCallback, useMemo } from 'react';
import {StyledLeadContainer, CreateLeadFooter, StyledSubHeader, StyledFlexEnd, StyledGridContainer} from '../../Components/Styled/index';
import {Box, Button, Typography, Link, Checkbox, FormControlLabel, Stack, Tooltip, IconButton } from '@mui/material';
import LeadAccordion from '../../Components/LeadAccordion';
import { privateRoutesPath } from '../../Routes';
import LeadDialog from '../../Components/LeadDialog';
import {useSnackbar} from 'notistack';
import { useEffect } from 'react';
import moment from 'moment';
import { getRequestData, getEntityColumns, validateFields, getAllowedValuesByEntity } from '../../Utility/apiHelper';
import LeadProduct from '../../Components/LeadProduct';
import DataGridTable from '../../Components/DataGrid';
import { useSelector, useDispatch } from 'react-redux';
import { createFilterOptions } from '@mui/material';
import { requestShowLoader, requestHideLoader, requestHideDialogLoader, requestShowDialogLoader } from '../../Store/Global/action';
import { requestGetAllActiveProducts } from '../../Store/Product/action';
import { createRequestData, updateRequestData } from '../../Utility/apiHelper';
import BiztantuLoader from '../../Components/Loader';
import 'react-quill/dist/quill.snow.css';
import DocumentManagement from '../../Components/DocumentManagement';
import { ACTIVITY_TYPE_LABELS, ACTIVE_STATUS, CUSTOMER_DOC_TYPE, LEAD_DESIRABILITY, LEAD_SOURCE, LEAD_STATUS, LEAD_STATUS_DEAL_CLOSED, PRODUCT_TYPE, STATIC_ENTITY_CONFIG,commonIncomeGroup, commonAgeGroup, commonMaritalStatus, commonTitles, emailWidth, handleValidateCodevalue, lead_customer_income, salesOrderStatus, phoneCountryCodes, ADDITIONAL_ATTRIBUTE_FIELDS,CUSTOMIZABLE_FIELDS_LEAD, getLeadScoreColor, CHILD_DATAGRIDTABLE_HEIGHT, ROWS_TO_VIEW_IN_CHILD_TABLE, searchEntity } from '../../Utility/constant';
import { EntityNote } from '../../Components/EntityNote';
import SelectBoxWithLabel from '../../Components/SelectBoxWithLable';
import AddressFields from '../../Components/AddressFields';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import WhoColumnTextfieds from '../../Components/WhoColumnTextfieds';
import TextFiledWithLabel from '../../Components/TextFieldWithLabel';
import CommonComm from '../../Components/CommonComm';
import AuditLogs from '../Configuration/Audit';

import AutoCompleteComponent from '../../Components/AutoCompleteComponenet';
import CommonPoc from '../../Components/CommonPoc';
import SendNotification from '../../Components/SendNotification';
import NotificationDialog from '../../Components/NotificationDialog';
import ViewLeadSuccessScore from './ViewLeadSuccessScore';
import ViewLeadSummary from './ViewLeadSummary';
import TruncatedTextCell from '../../Components/TruncatedTextCell';
import MarkunreadIcon from '@mui/icons-material/Markunread';
 import NotificationsIcon from '@mui/icons-material/Notifications';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { useIsMobile } from '../../Utility/hooks/useIsMobile';
import AddBoxIcon from '@mui/icons-material/AddBox';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CheckIcon from '@mui/icons-material/Check';
import TextDetailDialog from '../../Components/TextDetailDialog';
import { useCallContext } from '../../Components/TeleCalling/useCallContext';
import CallIcon from '@mui/icons-material/Call';
import { formatAdditionalAttributesForPayload } from '../../Utility/payloadFormatter';
import CustomizableFields from '../../Components/CustomizableFields';
import { FieldWithOpenLink } from '../../Components/FieldWithOpenLink';
import useViewMode from '../../Utility/hooks/useViewMode';
import useNavigation from '../../Utility/hooks/useNavigation';
import { useAccordionData } from '../../Utility/hooks/useAccordionData';
import './Lead.css';

const EditLead = (props) => {
    
  const location = useLocation();

  // Check if demo=true query parameter is present
  const searchParams = new URLSearchParams(location.search);
  const isDemoMode = searchParams.get('demo') === 'true';

  // Access state from the location
    const initialfollowup = {
        followupStatus: "",
        followupNote: "",
        followupDate: "",
        currentDate: "",
    }

    const initialfollowuperror = {
        followupNote: false,
        followupStatus: false,
        followupDate: false
    }
    const [showButton,isShowButton] = useState(true)
    // Audit Logs accordion — controlled via useAccordionData; fetches lazily on expand
    const auditAccordion = useAccordionData(null, { refetchOnEveryOpen: true, unmountOnExit: true });
    const setIsAuditAccordionExpanded = auditAccordion.setIsExpanded;

    const [isDialogOpen , setDialogOpenClose] = useState(false);
    const [selectedaddedproduct, setselectedaddedproduct] = useState([]);
    const [isLoading , seIsLoading] = useState(false);
    const initialState = {
        dialog  : false,
        checked : false,
        customerChecked : false,
        followup : false
    }
    const [isOpenDialog, setOpenDialog] = useState({
         ...initialState
    });
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [leadproduct, setLeadproduct] = useState([]);
    const [isDealCloseConfirm , setConfirmDealClosed] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [productQuantity, setproductQuantity] = useState(null);
    const [dialogProductData, setDialogProductData] = useState([]);
    const [selectedproduct, setSelectedproduct] = useState(null);
    const [selectedproductData, setSelectedProductData] = useState(null);
    const [leadFollowUpData, setLeadFollowUpData] = useState([]);
    const [pricerange, setpricerange] = React.useState([0, 100000000]);
    const ownerlist = useSelector(state => state?.owner?.ownerlist);
    const [requiredError, setRequiredError] = useState(initialfollowuperror);
    const specificRolePermission = useSelector(state => state?.owner?.rolebasedData);
    const internationalise = useSelector(state => state?.internationalise?.currentHashMapData);
    const activeProducts = useSelector(state => state?.product?.activeProducts);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [selectedDocumentType, setSelectedDocumentType] = useState(null);
    const [isRequired, setIsRequired] = useState({});
    const inputRef = useRef(null);
    const lookupData = useSelector(
        state => state?.lookup?.lookupData
    );

    const leadStatusData = useMemo(() => {
        return lookupData
            ?.find(item => item?.name === LEAD_STATUS)
            ?.codes
            ?.filter(item => item?.status === ACTIVE_STATUS)
            ?.sort((a, b) => a?.sequence - b?.sequence) ?? [];
    }, [lookupData]);
    const leadSourceData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == LEAD_SOURCE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const leadDesrirabilityData = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == LEAD_DESIRABILITY)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const productStaticType = useSelector(state => state?.lookup?.lookupData)?.find((item) => item?.name == PRODUCT_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const docType = useSelector(state=> state?.lookup?.lookupData)?.find((item) => item?.name == CUSTOMER_DOC_TYPE)?.codes?.filter(item => item?.status == ACTIVE_STATUS)?.sort((a,b) => a?.sequence - b?.sequence);
    const myTeam = useSelector(state => state?.owner?.Team);
    const currentUser = useSelector(state => state?.owner?.currentuser);
    const telecallingDetails = useSelector(state=> state?.telecalling?.telecallingDetails?.[0])
    const [isEntityLocked, setIsEntityLocked] = useState(true);

    const isMobile = useIsMobile();
    const allEntityData = useSelector((state) => state?.customization?.allEntityData || []);

    const leadTextfieldsData = useMemo(() => {
        const data = getEntityColumns(allEntityData, "LEAD");

        return Object.keys(data).length > 0
            ? data
            : STATIC_ENTITY_CONFIG?.LEAD;
    }, [allEntityData]);

    const { openInNewTab, navigateTo, goBackTo } = useNavigation();
    const goBack = () => goBackTo(privateRoutesPath.LEADS, searchEntity.lead);
    
    const modules = {
        toolbar: [
          [{ 'header': [1, 2, false] }],
          ['bold', 'italic',],
          [ {'list': 'bullet'}],
          ['link'],

        ],
      }
    
      const formats = [
        'header',
        'bold', 'italic',
        'list', 'bullet',
        'link'
      ]
//end editor configuration data


     const followupColumn = [
      
       { 
    field: 'note', 
    headerName: handleValidateCodevalue(internationalise,'LEAD_EDIT_FU_NOTE'),
    flex: 3,
    editable: false,
  renderCell: (params) => (
    <TruncatedTextCell
      text={params.value}
      dialogTitle="LEAD_EDIT_FU_NOTE"
      stripHtml={true}
      activityType={params.row.activityType}
      recipients={params.row.recipients}
      createdAt={params.row.createdAtRaw}
      callStatus={params.row.callStatus}
      callDuration={params.row.callDuration}
    />
  )
  },
    { 
            field: 'activityType', 
            headerName: handleValidateCodevalue(internationalise, 'COMMON_DETAILS') || 'Details',
            flex: 1,
            editable: false,
            renderCell: (params) => {
                return <span>{params.row.activityType ? ACTIVITY_TYPE_LABELS[params.row.activityType] || params.row.activityType : 'Note'}</span>;
            } 
        },
        { 
            field: 'status', 
            headerName: handleValidateCodevalue(internationalise,'LEAD_FU_STATUS'),
            flex: 1,
            editable: false,
            renderCell: (cellValues) => {
                return  <span>{handleValidateCodevalue(internationalise, cellValues?.row?.status)}</span>;
              } 
        },
          { 
            field: 'updatedByName', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_UPDATED_BY'),
            flex: 1,
            editable: false 
        },
      
        { 
            field: 'date', 
            headerName: handleValidateCodevalue(internationalise,'LEAD_FU_DATE'),
            flex: 1,
            editable: false 
        },
          { 
            field: 'nextdate', 
            headerName: handleValidateCodevalue(internationalise,'LEAD_EDIT_NEXT_FU_DATE'),
            flex: 1,
            editable: false 
        },
        
    ] 
    

    var filterdOptionlist = [];
    
    const isLoadingprogress = useSelector(state => state.global.isLoading); 
    const [followUp, setFollowUp] = useState(initialfollowup);
    const [inputprice, setInputprice] = useState({
        pricefromInput: 0,
        pricetoInput: 100000000
    })
    
    useEffect(() => {
        let priceRange = [parseInt(inputprice?.pricefromInput), parseInt(inputprice?.pricetoInput)]
        setpricerange(priceRange);
      }, [inputprice])

    const dispatch = useDispatch();
    const [currentLeadDetail, setCurrentLeadDetail] = useState({
        ...phoneCountryCodes,
        name: "",
        email: "",
        phone: "",
        source: "",
        income: "",
        product: [],
        ownerId: "",
        status: "",
        saleCommission: "",
        attributedValue: "",
    });
    
    const { isViewMode, canEdit, isOwner } = useViewMode({
        isAllManage : specificRolePermission?.isAllLeadManage,
        isTeamManage : specificRolePermission?.isLeadTeamManage,
        permission: specificRolePermission?.isLeadManage,
        isEntityLocked,
        ownerId: currentLeadDetail?.selectedOwner?.id,
    });
const allowedValues = useMemo(() => {
    if (!currentLeadDetail?.status) {
        return leadStatusData;
    }

    const values = getAllowedValuesByEntity(
        allEntityData,
        "LEAD",
        "LEAD_STATUS",
        currentLeadDetail.status
    );

    return values?.length > 0 ? values : leadStatusData;
}, [
    allEntityData,
    currentLeadDetail?.status,
    leadStatusData
]);
    const [initialLeadDetails, setInitialLeadDetails] = useState(null);
    useEffect(() => {
        if(leadproduct.length > 0) {
            
          const filterData = leadproduct.map(item => {
            return {
              ...item,
              type: item?.product?.type ,
              name: item?.product?.name,
              sellingPrice: item?.product?.sellingPrice,
              productId: item?.product?.id,
              grossprice: parseInt(item?.productQuantity)*parseFloat(item?.product?.sellingPrice),
              id: item?.leadProductId,
            }
          })
      
          setDialogProductData(filterData);
        }
  
      },[leadproduct])
  
    const leadId = props.match.params.id;

    const productTableColumn = [
        { 
            field: 'name', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_NAME'),
            flex: 1,
            editable: false 
        },
        { 
            field: 'productQuantity', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_QTY'),
            flex: 1,
            editable: true
        },
        { 
            field: 'unitOfMeasurement', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_UOM'),
            flex: 1,
            editable: true ,
            minWidth : emailWidth,
            valueGetter:({value})=>{
              if(!value){
                return ""
              }
              return handleValidateCodevalue(internationalise,value)
            }
        },
        { 
            field: 'sellingPrice', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_SP'),
            flex: 1,
            editable: false 
        },
        { 
            field: 'discountAmount', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_DA'),
            flex: 1,
            editable: false 
        },
        { 
            field: 'primaryDiscount', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_PD'),
            flex: 1,
            editable: false 
        },
        { 
            field: 'cGst', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_CGST'),
            flex: 1,
            editable: false 
        },
        { 
            field: 'sGst', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_SGST'),
            flex: 1,
            editable: false 
        },
        { 
            field: 'surchargeRate', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_SURCHARGE'),
            flex: 1,
            editable: false 
        },
        { 
            field: 'grandTotal', 
            headerName: handleValidateCodevalue(internationalise,'COMMON_PROD_TP'),
            flex: 1,
            editable: false 
        },
        
    ]
    // Fetch all lead data — runs only when leadId changes
    useEffect(() => {
        getLeadDetails(leadId);
        getFollowUpDetails(leadId);
        getLeadProductDetails(leadId);
    }, [leadId]);

    useEffect(() => {
        dispatch(
            requestGetAllActiveProducts({
                params: {
                    status: "PRODUCT_STATUS_ACTIVE"
                }
            })
        );
    }, [dispatch]);

    // When ownerlist/myTeam arrive in Redux (after initial load),
    // update only the selectedOwner display without re-fetching APIs
    useEffect(() => {
        if (!currentLeadDetail?.ownerId || (!ownerlist?.length && !myTeam?.length)) return;

        const list = specificRolePermission?.isAllLeadManage
            ? ownerlist
            : specificRolePermission?.isLeadTeamManage
            ? myTeam
            : [];

        const filteredOwner = list?.find(item => currentLeadDetail.ownerId === item?.id);
        if (!filteredOwner) return;

        // Skip update if selectedOwner is already populated with the matching owner
        if (currentLeadDetail?.selectedOwner?.id === filteredOwner?.id) return;

        setCurrentLeadDetail(prev => ({ ...prev, selectedOwner: filteredOwner, currentOwnerId: filteredOwner?.id }));
        setInitialLeadDetails(prev => prev ? ({ ...prev, selectedOwner: filteredOwner, currentOwnerId: filteredOwner?.id }) : prev);
    }, [ownerlist, myTeam, currentLeadDetail?.ownerId, currentLeadDetail?.selectedOwner?.id, specificRolePermission]);

    useEffect(() => {
        if (currentLeadDetail?.status && !followUp.followupNote) {
            setFollowUp(prevFollowUp => ({
                ...prevFollowUp,
                followupStatus: currentLeadDetail.status
            }));
        }
    }, [currentLeadDetail?.status]);

    // Entity lock control: starts locked to prevent flash of editable content.
    // Once both lead status and lookup codes are ready, locks if closed/cancelled,
    // or unlocks if confirmed to be an open lead.
    useEffect(() => {
        if (!currentLeadDetail?.status || !leadStatusData?.length) return;

        const matched = leadStatusData.find(item => item?.name === currentLeadDetail.status);
        const isClosedOrCancelled =
            matched?.systemLookupCode?.name === LEAD_STATUS_DEAL_CLOSED ||
            matched?.systemLookupCode?.name === "LEAD_STATUS_CANCELLED";

        if (isClosedOrCancelled) {
            setIsEntityLocked(true);
            isShowButton(false);
        } else if (matched) {
            setIsEntityLocked(false);
            isShowButton(true);
        }
    }, [currentLeadDetail?.status, leadStatusData]);

    const getFollowUpDetails = useCallback(async (leadId) => {
        seIsLoading(true);

        const response = await getRequestData(`leads/${leadId}/followup`);

        seIsLoading(false);

        if (response?.status === "error") {
            setLeadFollowUpData([]);
            return;
        }

        const leadData = response.data;

        if (leadData.length > 0) {
            const leadFollowUpData = leadData.map(item => ({
                id: item?.id,
                note: item?.note,
                status: item?.status,
                updatedBy: item?.updatedBy,
                nextdate: item?.followupDate
                    ? moment(item.followupDate).format("MM/DD/YYYY")
                    : "",
                date: item?.createdAt
                    ? moment(item.createdAt).format("MM/DD/YYYY")
                    : "",
                updatedByName: item?.updatedByName,
                // Structured activity metadata (null for legacy rows)
                activityType: item?.activityType ?? null,
                recipients: item?.recipients ?? null,
                createdAtRaw: item?.createdAt ?? null,
                callStatus: item?.callStatus ?? null,
                callDuration: item?.callDuration ?? null,
            }));

    setLeadFollowUpData(leadFollowUpData);
} else {
    setLeadFollowUpData([]);
}

    }, []);

    const getLeadDetails = async (leadId) => {
        
        dispatch(requestShowLoader());

        const response = await getRequestData(`leads/${leadId}`);

        dispatch(requestHideLoader());

        if (response?.status === "error") {
            return;
        }

        const leadData = response.data;

        const filteredOwner = (
            (specificRolePermission?.isAllLeadManage
                ? ownerlist
                : specificRolePermission?.isLeadTeamManage
                ? myTeam
                : [{
                    firstName: currentUser?.firstname,
                    lastName: currentUser?.lastname,
                    id: currentUser?.userId,
                }]) || []
        ).find(item => leadData?.ownerId === item?.id);

        const filteredSource = leadSourceData?.find(
            item => leadData?.source === item?.name
        );

        setCurrentLeadDetail({
            ...leadData,
            id: leadData?.id,
            createdat: moment(leadData.created).format("MM/DD/YYYY"),
            updatedat: moment(leadData.updated).format("MM/DD/YYYY"),
            ownerId: leadData?.ownerId,
            currentOwnerId: filteredOwner?.id,
            selectedOwner: filteredOwner,
            selectedSource: filteredSource,
        });

        setInitialLeadDetails({
            ...leadData,
            id: leadData?.id,
            createdat: moment(leadData.created).format("MM/DD/YYYY"),
            updatedat: moment(leadData.updated).format("MM/DD/YYYY"),
            ownerId: leadData?.ownerId,
            currentOwnerId: filteredOwner?.id,
            selectedOwner: filteredOwner,
            selectedSource: filteredSource,
        });

        const isDealClosed = leadStatusData?.find(
            item => item?.name === leadData?.status
        );

        if (
            isDealClosed?.systemLookupCode?.name === LEAD_STATUS_DEAL_CLOSED ||
            isDealClosed?.systemLookupCode?.name === "LEAD_STATUS_CANCELLED"
        ) {
            setIsEntityLocked(true);
            isShowButton(false);
        } else if (isDealClosed) {
            setIsEntityLocked(false);
            isShowButton(true);
        }
    }


    const handleChangeLeadData = (event) => {
        setCurrentLeadDetail({
            ...currentLeadDetail,
            [event.target.name]: event.target.value
        })
    }

    const handleChangeFollowup = (event) => {
        setFollowUp({
            ...followUp,
            [event.target.name]: event.target.value
        })
    }

    const handleFollowupmethod = async(payload, isdealclosed = false) => {
        dispatch(requestShowDialogLoader());
        const response = await createRequestData(payload,`leads/${leadId}/followup`);

    if (response?.status === "error") {
        enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
                "COMMON_PLEASE_TRY_AGAIN"
            ),
            { variant: "error" }
        );

        dispatch(requestHideDialogLoader());
        seIsLoading(false);
        return;
    }

    setIsAuditAccordionExpanded(false);

    setFollowUp({
        ...initialfollowup,
        followupStatus: payload?.status || "",
    });

    if (isOpenDialog?.followup || isOpenDialog?.dialog) {
        setOpenDialog({
            ...initialState,
        });
    }

    getFollowUpDetails(leadId);
    getLeadDetails(leadId);

    if (isdealclosed) {
        enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
                "LEAD_DC_SUCCESSFULLY"
            ),
            { variant: "success" }
        );
    } else {
        enqueueSnackbar(
            handleValidateCodevalue(
                internationalise,
                "LEAD_FU_ADDED_SUCCESSFULLY"
            ),
            { variant: "success" }
        );
    }

dispatch(requestHideDialogLoader());
    }

    const handleSaveFollowUp = () => {
        if(followUp?.followupNote && followUp?.followupStatus) {
            const payload = {
                "note": followUp.followupNote,
                "status": followUp.followupStatus,
                "currentDate": moment(new Date()).format('MM/DD/YYYY')
            }
            if (followUp.followupDate) {
                payload.followupDate = followUp.followupDate;
            }
            const isDealClosed = leadStatusData?.find(item=> item?.name == followUp.followupStatus)
            const dealclosed = isDealClosed?.systemLookupCode?.name == LEAD_STATUS_DEAL_CLOSED
            if(dealclosed) {
                setOpenDialog({
                    ...isOpenDialog,
                    dialog : true
            });
                setRequiredError({
                    ...requiredError,
                    followupNote: false,
                    followupStatus: false,
                })
            } 
            
            if(!dealclosed) {
                handleFollowupmethod(payload, false);
                setRequiredError({
                    ...requiredError,
                    followupNote: false,
                    followupStatus: false,
                    followupDate: false
                })
            } else {
                setRequiredError({
                    ...requiredError,
                    followupNote: true,
                    followupStatus: true,
                })
            }

        } else {    
            setRequiredError({
                ...requiredError,
                followupNote: true,
                followupStatus: true,
                followupDate: true
            })
        }

        
    }

    const handleUpdateLaed = async (value = false) => {
        const {errors,hasError} = validateFields(leadTextfieldsData, currentLeadDetail);
        if (hasError) {
        setIsRequired(errors);
        inputRef?.current?.focus();
        enqueueSnackbar(
            handleValidateCodevalue(internationalise, "COMMON_MSG_MANDATORY_FIELDS"),
            { variant: "error" }
        );
        return;
        } else {
        setIsRequired({});
        if(JSON.stringify(initialLeadDetails) == JSON.stringify(currentLeadDetail)) {
            if(value == true){
                goBack();
            } else {
                enqueueSnackbar(handleValidateCodevalue(internationalise,"COMMON_NO_DATA_CHANGED"), {variant: 'info'});
            }
        } else {
            dispatch(requestShowLoader());
            const { updatedat, id, ...updatedLead} = currentLeadDetail;
                       const reqpayload = formatAdditionalAttributesForPayload(
                       {
                           ...updatedLead,
                       },
                       [...ADDITIONAL_ATTRIBUTE_FIELDS,...CUSTOMIZABLE_FIELDS_LEAD]
                       );
                        const response = await updateRequestData(reqpayload,`leads/${leadId}`);

                        if (response?.status === "error") {
                            enqueueSnackbar(
                                handleValidateCodevalue(
                                    internationalise,
                                    response?.propererror?.data?.message ||
                                        "COMMON_PLEASE_TRY_AGAIN"
                                ),
                                { variant: "error" }
                            );

                            dispatch(requestHideLoader());
                            return;
                        }

                        enqueueSnackbar(
                            handleValidateCodevalue(
                                internationalise,
                                "COMMON_UPDATED_SUCCESSFULLY"
                            ),
                            { variant: "success" }
                        );

                        const leadData = response.data;

                        const filteredOwner = ownerlist?.find(
                            item => leadData?.ownerId === item?.id
                        );

                        const filteredSource = leadSourceData?.find(
                            item => leadData?.source === item?.name
                        );

                        setCurrentLeadDetail({
                            ...leadData,
                            currentOwnerId: filteredOwner?.id,
                            selectedOwner: filteredOwner,
                            selectedSource: filteredSource,
                        });

                        setInitialLeadDetails({
                            ...leadData,
                            currentOwnerId: filteredOwner?.id,
                            selectedOwner: filteredOwner,
                            selectedSource: filteredSource,
                        });

                        setIsAuditAccordionExpanded(false);
                        dispatch(requestHideLoader());

                        if (value === true) {
                            goBack();
                        }
        }}
          
    }
    const handleClose = () => {
        setDialogOpenClose(false);
    };

    const getLeadProductDetails = async(leadId) => {
        const reqUrl = `${process.env.REACT_APP_BASE_URL}leadproducts/search?leadid=${leadId}`;
        const responseData = await getRequestData(reqUrl);
        if(responseData?.data) {
            const productdata = responseData?.data;
            const tableproductData = productdata.sort((a,b) => new Date(b?.updated) - new Date(a?.updated)).map(item => {
                return {
                    ...item,
                    unitOfMeasurement : item?.product?.unitOfMeasurement,
                    id: item?.leadProductId,
                    sellingPrice : item?.sellingPrice,
                    quantity : item?.productQuantity,
                    grossprice: parseInt(item?.productQuantity)*parseFloat(item?.product?.sellingPrice),
                    priceAfterDiscount : (item?.sellingPrice - (item?.sellingPrice * item?.primaryDiscount)/100) * item?.productQuantity,
                    unitDiscountAmount : item?.sellingPrice- (item?.sellingPrice - (item?.sellingPrice * item?.primaryDiscount)/100)
                }
            })
            setLeadproduct(tableproductData);
        }
    }

    const handleAddLeadProduct = async() => {
        const reqProduct = selectedaddedproduct.map(item => {
            return {
                "leadId":leadId,
                "productId": item?.id,
                "productQuantity": 1,
                sellingPrice : item?.price,
                primaryDiscount : item?.primaryDiscount,
                sGst : item?.sgstRate,
                cGst : item?.cgstRate,
                surchargeRate : item?.surChangeRate 
            }
        })
        dispatch(requestShowLoader());
        const reqUrl = `${process.env.REACT_APP_BASE_URL}leadproducts/multiple`
        const responseData = await createRequestData(reqProduct,reqUrl);
        if(responseData?.status == 200) {
            setIsAuditAccordionExpanded(false);
            getLeadProductDetails(leadId);
            enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_ADDED_SUCCESSFULLY'), { variant: 'success' });
            setselectedaddedproduct([]);
            dispatch(requestHideLoader());
            return true;
        } else {
            enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_PLEASE_TRY_AGAIN'), {variant: 'error'});
            dispatch(requestHideLoader());
            return false;
        }
    }

    const handleAddRecommendedProduct = async (selectedRecommendations) => {
        const selectedSet = new Set(selectedRecommendations);
        const selectedProducts = (activeProducts || []).filter(product =>
            selectedSet.has(product.id)
        );

        const reqProduct = selectedProducts.map(item => ({
            leadId: leadId,
            productId: item.id,
            productQuantity: 1,
            sellingPrice: item.price,
            primaryDiscount: item.primaryDiscount,
            sGst: item.sgstRate,
            cGst: item.cgstRate,
            surchargeRate: item.surChangeRate
        }));

        dispatch(requestShowLoader());

        const response = await createRequestData(
            reqProduct,
            `${process.env.REACT_APP_BASE_URL}leadproducts/multiple`
        );

        dispatch(requestHideLoader());

        if (response?.status === 200) {
            setIsAuditAccordionExpanded(false);
            getLeadProductDetails(leadId);
            enqueueSnackbar(
                handleValidateCodevalue(
                    internationalise,
                    "COMMON_ADDED_SUCCESSFULLY"
                ),
                { variant: "success" }
            );
        } else {
            enqueueSnackbar(
                handleValidateCodevalue(
                    internationalise,
                    "COMMON_PLEASE_TRY_AGAIN"
                ),
                { variant: "error" }
            );
        }
    };

    
    const handleUpdateLeadproduct = async(reqObj) => {
        const reqPayload = {
            ...reqObj,
            "leadId": leadId,
            "productId": reqObj?.productId,
            "productQuantity": parseFloat(reqObj?.quantity),
            sellingPrice : reqObj?.price,
            primaryDiscount : reqObj?.primaryDiscount,
            sGst : reqObj?.sgstRate,
            cGst : reqObj?.sgstRate,
            surchargeRate : reqObj?.surChangeRate 
        }
        dispatch(requestShowLoader());
        const url = `${process.env.REACT_APP_BASE_URL}leadproducts/${reqObj?.leadProductId}`;
        const responseData = await updateRequestData(reqPayload,url);
        if(responseData?.status == 200) {
            setIsAuditAccordionExpanded(false);
            await getLeadProductDetails(leadId);
            enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_UPDATED_SUCCESSFULLY'), {variant: 'success'});
            dispatch(requestHideLoader());
        } else {
            dispatch(requestHideLoader()); 
            enqueueSnackbar(handleValidateCodevalue(internationalise,'COMMON_PLEASE_TRY_AGAIN'), {variant: 'error'});
       }
    }


    const handleChangeQuantity = (e) => {
        setproductQuantity(e.target.value)
    }

    
    const handleDealClose = async() => {
        try{
        dispatch(requestShowDialogLoader());
        const selectedProductData = dialogProductData.filter(({leadProductId}) => selectionModel.includes(leadProductId));
        const payload = {
                "note": followUp.followupNote,
                "status": followUp.followupStatus,
                "currentDate": moment(new Date()).format('MM/DD/YYYY'),
                "leadProducts": [],
                "createOrderFlag" : isOpenDialog?.checked,
                createCustomerFlag : isOpenDialog?.customerChecked
            }
        if (followUp.followupDate) {
            payload.followupDate = followUp.followupDate;
        }
        selectedProductData.map((item, index) => {
            payload.leadProducts.push({
                ...item,
                "id": item?.id,
            })
        });
  
                handleFollowupmethod(payload, true);
                setConfirmDealClosed(false);
                if(isOpenDialog?.followup){
                    setOpenDialog({
                        ...initialState
                    });
                }
                setRequiredError(initialfollowuperror);
                // enqueueSnackbar(`Order Created Successfully.`, {
                //     action: (snackbarId) => action(snackbarId , orderresponse?.data?.id),
                //     persist: true,
                //     variant: 'success'
                // })
            }
            catch{

            }
            finally {
                dispatch(requestHideDialogLoader());
            }
            }
            


    const handleCopyCreateLead = () => {
            
            const copyLeadRequiredData = {
               ...currentLeadDetail,
            }
            navigateTo(`${privateRoutesPath?.CREATE_LEAD}`,
                {
                    currentLeadDetail: copyLeadRequiredData,
                    currentLeadProductDetails : leadproduct,
                },
                searchEntity?.lead
            )
    }


    const handleSelectMultiproduct = (event, productData, reason) => {
        if (productData.find(option => option.value === "select-all")) {
            setselectedaddedproduct([...selectedaddedproduct,...filterdOptionlist]);
        } else {
            setselectedaddedproduct(productData);
        } 
    }

    const filter = createFilterOptions();

    
    const handleFilterOption = (options, params) => {
         filterdOptionlist = filter(options, params);
         return [ { name: 'Select All', price: "", value: "select-all" }, ...filterdOptionlist];
    }

    const handlechangeInputprice = (event) => {
        setInputprice({
            ...inputprice,
            [event.target.name]: event.target.value
        })
    }

    const handleChangeDocument = (event) => {

        const file = event.target.files[0];

        if(file) {
            setSelectedDocumentType({
                ...selectedDocumentType,
                [event.target.name]: file
            })

        } else {
            setSelectedDocumentType({
                ...selectedDocumentType,
                [event.target.name]: event.target.value
            })
        }
       
    }


    const handleAuditAccordionChange = auditAccordion.onAccordionChange;
    
    const {subTotal,totalGst,discountAmount,cGstAmount,sGstAmount,surchargeAmount,priceAfterDiscount,finalPrice} = 
    dialogProductData.reduce(
  (acc, item) => {
    const sub = Number(item.subTotal || 0);
    const discount = Number(item.discountAmount || 0);
    const cgst = Number(item.cGstAmount || 0);
    const sgst = Number(item.sGstAmount || 0);
    const surcharge = Number(item.surchargeAmount || 0);

    // 🧮 Accumulate all individual totals
    acc.subTotal += sub;
    acc.discountAmount += discount;
    acc.cGstAmount += cgst;
    acc.sGstAmount += sgst;
    acc.surchargeAmount += surcharge;

    // 🧩 Derived values
    acc.priceAfterDiscount = acc.subTotal - acc.discountAmount;
    acc.totalGst = acc.cGstAmount + acc.sGstAmount;
    const totalTax = acc.cGstAmount + acc.sGstAmount + acc.surchargeAmount;
    acc.finalPrice = acc.priceAfterDiscount + totalTax; // if taxes are added after discount

    return acc;
  },
  {
   totalGst:0,subTotal: 0,discountAmount: 0,cGstAmount: 0,sGstAmount: 0,surchargeAmount: 0,priceAfterDiscount: 0,finalPrice: 0,
}
);

    const handleSelectCompany =(e,val,entity)=>{
        if(entity === "Source"){
        setCurrentLeadDetail({
            ...currentLeadDetail,
            selectedSource : val,
            source : val?.name
        })
    }
        if(entity === "Owner"){
            setCurrentLeadDetail({
            ...currentLeadDetail,
            selectedOwner : val,
            ownerId : val?.id
        })
        }
    }
const handleOpenNotificationPopup = useCallback(async (isWhatsapp = false,channel)=> {
setIsOpenNotificationDialog({
        selectedDetails: [currentLeadDetail?.id], 
        isOpen: true,
        isWhatsapp : isWhatsapp,
        channel : channel
    });
}, [currentLeadDetail]);

const { startOutgoingCall, registerPageCallHint, clearPageCallHint } = useCallContext();

useEffect(() => {
  if (currentLeadDetail?.phone) {
    registerPageCallHint({
      ClientId: currentUser?.client?.id,
      userId: currentUser?.userId,
      LeadId: leadId,
      phone: currentLeadDetail?.phone,
      phoneCountryCode: currentLeadDetail?.phoneCountryCode || "+91",
      title: handleValidateCodevalue(internationalise, "COMMON_NOTIFY_LEAD") || "Notify Lead",
      onCallActivityReady: () => getFollowUpDetails(leadId),
    });
  } else {
    clearPageCallHint();
  }
  
  return () => clearPageCallHint();
}, [currentLeadDetail?.phone, currentLeadDetail?.phoneCountryCode, leadId, currentUser, internationalise, registerPageCallHint, clearPageCallHint, getFollowUpDetails]);

const [isOpenNotificationDialog,setIsOpenNotificationDialog] = useState({
    selectedTemplate : null,
    isOpen : false,
})

const [isOpenScoreDialog, setIsOpenScoreDialog] = useState(false);
const [isOpenGuideDialog, setIsOpenGuideDialog] = useState(false);

const [openNotifyBox,setOpenNotifyBox] = useState()

const handleOpenNotifyBox = () => {
  const Owner = ownerlist?.find(item => item?.id === currentLeadDetail?.currentOwnerId )
  setOpenNotifyBox({
    open : true,
    destinationId : leadId,
    receiverId : Owner?.id,
    ownerName : `${Owner?.firstName} ${Owner?.lastName}`
  })
}

const handleCloseDialog = () => {
  setOpenNotifyBox({
    message : "",
    open : false,
    ownerName : "",
    required : false
  })
}
const handleEmailSent = ()=>{
        setIsAuditAccordionExpanded(false);
        getLeadDetails(leadId);
        getFollowUpDetails(leadId);
        getLeadProductDetails(leadId);
}

const [isOpenFollowupPopup,setIsOpenFollowupPopup] = useState({
    open : false,
    selectedCard : null
})
const handleCardClick = (card) => {
  setIsOpenFollowupPopup({
    open: true,
    selectedCard: card
  });
};
const renderValuesOnCard = [
    { field: "status", useChip : true,left : true },
    { field: "updatedBy",useAvatar : true,right : true },
    { field: "date",useLabel : "LEAD_FU_DATE" ,type : "date" },
    { field: "nextdate",useLabel : "LEAD_EDIT_NEXT_FU_DATE" ,type : "date" },
    { field: "note",stripHtml:true,truncate : true, },
]

const renderValuesOnCardOfProduct = [
    { field: "additionDate"},
    { field: "quantity",useLabel : "COMMON_PROD_QTY" },
    { field: "unitOfMeasurement",useLabel:"COMMON_PROD_UOM" },
    { field: "grandTotal" ,useLabel : "COMMON_PROD_TP"}
]

const FollowUpForm = (
    <React.Fragment
    >
        <TextFiledWithLabel 
            className={`${isMobile ? '' : 'ml-20 '}edit-lead-followup-note`}
            id="standard-basic" 
            label={handleValidateCodevalue(internationalise,"LEAD_EDIT_FU_NOTE")} 
            name="followupNote"
            value={followUp.followupNote}
            handleOnChange={handleChangeFollowup}
            error={followUp?.followupNote ? false : requiredError?.followupNote}
        />
        <TextFiledWithLabel
            className={`${isMobile ? 'mt-15 ' : ''}edit-lead-followup-date`}
            id="lead-follow-up"
            type="date"
            name="followupDate"
            value={followUp.followupDate}
            label={handleValidateCodevalue(internationalise,"LEAD_EDIT_NEXT_FU_DATE")}
            handleOnChange={handleChangeFollowup}
            InputLabelProps={{ shrink: true }}
        />
        <SelectBoxWithLabel
            className={`${isMobile ? 'mt-15 ' : ''}edit-lead-followup-status`}
            ownerdropdown = {false}
            isStatic = {false}
            required={true}
            id="lead-followup-status"
            name="followupStatus"
            select
            error={followUp?.followupStatus ? false : requiredError?.followupStatus}
            value={followUp.followupStatus || ""}
            label={handleValidateCodevalue(internationalise,"LEAD_FU_STATUS")}
            optionMenuItem={allowedValues}
            handleOnChange={handleChangeFollowup}
        />
        </React.Fragment>
);
    const handleTelecallingClose = useCallback(() => {
        getFollowUpDetails(leadId);
    }, [getFollowUpDetails]);
    
    const configLabels = STATIC_ENTITY_CONFIG?.LEAD
    
    useEffect(()=>{
        if(!isOpenDialog?.customerChecked){
        setOpenDialog({
            ...isOpenDialog,
                checked : false
            })
        }
    },[isOpenDialog?.customerChecked])

    return (
        <BiztantuLoader open={isLoadingprogress} isChildren={true}>
        <React.Fragment>           
            <Box className= {isMobile ?  'globalBoxMobile' : 'globalBox'}>
                <LeadAccordion
                    label={`${handleValidateCodevalue(internationalise,'LEAD_EDIT_LEAD_DETAILS')} - ${leadId}`}
                >
                    {!isViewMode && 
                    <Box className = "mt-15 mb-10">
                    <Button className='edit-primary' variant="outlined"  onClick={handleUpdateLaed}>{handleValidateCodevalue(internationalise,"COMMON_SAVE")}</Button>
                    <Button className='edit-primary btn-space' variant="outlined"  onClick={()=>handleUpdateLaed(true)}>{handleValidateCodevalue(internationalise,"COMMON_SAVE_AND_EXIT")}</Button>
                </Box>}
        <StyledGridContainer>

    <TextFiledWithLabel
        name="id"
        id="id" 
        value={currentLeadDetail.id}
        disabled="true"
        label={handleValidateCodevalue(internationalise,configLabels?.id?.label)} 
    />

    <FieldWithOpenLink
        id = {currentLeadDetail?.customerId}
        href={
        currentLeadDetail?.customerId
            ? `${privateRoutesPath?.EDIT_CUSTOMER}/${currentLeadDetail?.customerId}`
            : null
        }
        tooltip={handleValidateCodevalue(internationalise,"LEAD_OPEN_CUSTOMER")}
    >
        <TextFiledWithLabel
            name="customerId"
            id="customerId" 
            value={currentLeadDetail?.customerId}
            disabled
            label={handleValidateCodevalue(internationalise,configLabels?.customerId?.label)} 
        />
    </FieldWithOpenLink>
    <AutoCompleteComponent
        isViewMode = {isViewMode}
        isOwner={true}
        optionSet = {(specificRolePermission?.isAllLeadManage ? ownerlist 
            : specificRolePermission?.isLeadTeamManage ? myTeam 
            : [{
        firstName: `${currentUser?.firstname}`,
        lastName : `${currentUser?.lastname}`,
        id: currentUser?.userId,
      }]) || []}
        value={currentLeadDetail?.selectedOwner || null}
        disabled= {isViewMode || !(specificRolePermission?.isAllLeadManage || specificRolePermission?.isLeadTeamManage)}
        name = "clientId"
        placeholder={handleValidateCodevalue(internationalise,configLabels?.selectedOwner?.label)}
        error={currentLeadDetail?.selectedOwner ? false : !!isRequired?.selectedOwner}
        required={true}
        label={handleValidateCodevalue(internationalise,configLabels?.selectedOwner?.label)}       
        onChange={(e, val) => handleSelectCompany(e, val, "Owner")}
    />
    <TextFiledWithLabel
        name="status"
        handleOnChange={handleChangeLeadData}
        id="leadstatus"
        disabled 
        value={handleValidateCodevalue(internationalise,currentLeadDetail?.status)}
        label={handleValidateCodevalue(internationalise,configLabels?.status?.label)}
    />
    <CustomizableFields
        CUSTOMIZABLE_FIELDS = {["title"]}
        useWrapper={false}
        showHeader={false}
        entity = "LEAD"
        isViewMode={isViewMode}
        config={leadTextfieldsData}
        values={currentLeadDetail}
        setValues = {setCurrentLeadDetail}
        handleOnChange={handleChangeLeadData}
        errors={isRequired}
    />

    {leadTextfieldsData?.firstName?.visibility && (
    <TextFiledWithLabel
        name="firstName"
        error={currentLeadDetail?.firstName ? false : !!isRequired?.firstName}
        required={leadTextfieldsData?.firstName?.mandatory}
        disabled={isViewMode}
        id="firstName"
        label={handleValidateCodevalue(internationalise, configLabels?.firstName?.label)}
        handleOnChange={handleChangeLeadData}
        value={currentLeadDetail?.firstName || ""}
    />
    )}

    {leadTextfieldsData?.lastName?.visibility && (
    <TextFiledWithLabel
        name="lastName"
        error={currentLeadDetail?.lastName ? false : !!isRequired?.lastName}
        required={leadTextfieldsData?.lastName?.mandatory}
        disabled={isViewMode}
        id="lastName"
        label={handleValidateCodevalue(internationalise, configLabels?.lastName?.label)}
        handleOnChange={handleChangeLeadData}
        value={currentLeadDetail?.lastName || ""}
    />
    )}

    {leadTextfieldsData?.externalNumber?.visibility && (
    <TextFiledWithLabel
        name="externalNumber"
        error={currentLeadDetail?.externalNumber ? false : !!isRequired?.externalNumber}
        required={leadTextfieldsData?.externalNumber?.mandatory}
        disabled={isViewMode}
        id="externalNumber"
        label={handleValidateCodevalue(internationalise, configLabels?.externalNumber?.label)}
        handleOnChange={handleChangeLeadData}
        value={currentLeadDetail?.externalNumber || ""}
    />
    )}

    {leadTextfieldsData?.selectedSource?.visibility && (
    <AutoCompleteComponent
        isLookup={true}
        isViewMode={isViewMode}
        optionSet={leadSourceData}
        error={currentLeadDetail?.selectedSource ? false : !!isRequired?.selectedSource}
        value={currentLeadDetail?.selectedSource || null}
        name="clientId"
        required={leadTextfieldsData?.selectedSource?.mandatory}
        placeholder={handleValidateCodevalue(internationalise, configLabels?.selectedSource?.label)}
        label={handleValidateCodevalue(internationalise, configLabels?.selectedSource?.label)}
        onChange={(e, val) => handleSelectCompany(e, val, "Source")}
    />
    )}

    {leadTextfieldsData?.occupation?.visibility && (
    <TextFiledWithLabel
        name="occupation"
        error={currentLeadDetail?.occupation ? false : !!isRequired?.occupation}
        required={leadTextfieldsData?.occupation?.mandatory}
        disabled={isViewMode}
        id="occupation"
        label={handleValidateCodevalue(internationalise, configLabels?.occupation?.label)}
        handleOnChange={handleChangeLeadData}
        value={currentLeadDetail?.occupation || ""}
    />
    )}


    {leadTextfieldsData?.desirability?.visibility && (
    <SelectBoxWithLabel
        ownerdropdown={false}
        isStatic={false}
        disabled={isViewMode}
        error={currentLeadDetail?.desirability ? false : !!isRequired?.desirability}
        name="desirability"
        required={leadTextfieldsData?.desirability?.mandatory}
        value={currentLeadDetail?.desirability || ""}
        label={handleValidateCodevalue(internationalise, configLabels?.desirability?.label)}
        optionMenuItem={leadDesrirabilityData}
        handleOnChange={handleChangeLeadData}
    />
    )}

    {leadTextfieldsData?.totalValue?.visibility && (
    <TextFiledWithLabel
        name="totalValue"
        required={leadTextfieldsData?.totalValue?.mandatory}
        label={handleValidateCodevalue(internationalise, configLabels?.totalValue?.label)}
        value={finalPrice || ""}
        disabled
    />
    )}
    
                <CustomizableFields
                CUSTOMIZABLE_FIELDS={
                CUSTOMIZABLE_FIELDS_LEAD.filter(
                    field => field !== "title"
                        )
                    }
                isViewMode={isViewMode}
                useWrapper={false}
                showHeader={false}
                entity = "LEAD"
                config={leadTextfieldsData}
                values={currentLeadDetail}
                setValues = {setCurrentLeadDetail}
                handleOnChange={handleChangeLeadData}
                errors={isRequired}
                />
</StyledGridContainer>

                <CustomizableFields
                CUSTOMIZABLE_FIELDS={ADDITIONAL_ATTRIBUTE_FIELDS}
                entity = "LEAD"
                setValues = {setCurrentLeadDetail}
                config={leadTextfieldsData}
                values={currentLeadDetail}
                handleOnChange={handleChangeLeadData}
                isViewMode={isViewMode}
                errors={isRequired}
                />

            {specificRolePermission?.isAimlManage &&
            <>
                <StyledSubHeader 
                className = "mb-10"
                >
                {handleValidateCodevalue(
                    internationalise,
                    "LP_AI"
                )}
                </StyledSubHeader>
                <StyledGridContainer className = "mb-20">
                    <Tooltip title={handleValidateCodevalue(internationalise,"LP_SUCCESS_AI")}>
                        <Button 
                            style={{
                                backgroundColor: getLeadScoreColor(currentLeadDetail?.leadScore)
                            }}
                            className='secondry-edit-btn edit-lead-score-btn' 
                            pl = "0"variant="outlined" 
                            onClick={() => setIsOpenScoreDialog(true)}
                        >
                            {handleValidateCodevalue(internationalise,"LP_SUCCESS_AI")}
                            {currentLeadDetail?.leadScore != null ? ` - ${currentLeadDetail.leadScore}%` : ''}
                        </Button>
                    </Tooltip>
                </StyledGridContainer>
                </>
            }

                <WhoColumnTextfieds
                entityDetails={currentLeadDetail}
                />
                <CommonComm
                isViewMode={isViewMode}
                 required= {true}
                 isDetailPage = {true}
                 requiredValue={isRequired}
                 handleOnChange={handleChangeLeadData}
                 state = {currentLeadDetail}/>
                    <AddressFields
                    setEntityDetails={setCurrentLeadDetail}
                    disabled = {isViewMode}
                    onChange={handleChangeLeadData}
                    entityDetails={currentLeadDetail}
                                        />
                    <CommonPoc
                        isViewMode = {isViewMode}
                        isDetailPage={true}
                        requiredValue={false}
                        handleOnChange={handleChangeLeadData}
                        state={currentLeadDetail}
                    />
                    <EntityNote
                    isViewMode = {isViewMode}
                    entityDetails = {currentLeadDetail} 
                    onChange = {handleChangeLeadData}
                    headingLabel = {handleValidateCodevalue(internationalise,"COMMON_SPECIAL_NOTE")}
                    />
                </LeadAccordion>
                    

                    <LeadAccordion
                        label={handleValidateCodevalue(internationalise,'LEAD_EDIT_FOLLOW_UP')}
                        defaultOpen={true}
                    >
                    
                    {!isViewMode &&
                        <StyledLeadContainer className='mb-10 edit-lead-followup-container'>
                        {!isMobile &&
                            <StyledLeadContainer className='icon-Container edit-lead-followup-icon-container'>
                        {FollowUpForm}
                        
                        <Button 
                    className='biztantu-sec-btn edit-lead-add-btn' variant="contained" size="large" name="followupbtn" 
                    onClick={() => {
                        if (isMobile) {
                            setOpenDialog({
                                ...isOpenDialog,
                                    followup: true
                            });
                        } else {
                            handleSaveFollowUp();
                        }
                    }}
             >{handleValidateCodevalue(internationalise,"COMMON_ADD")}</Button>
                            </StyledLeadContainer>
                    }
                         {isMobile && isOpenDialog?.followup && (
                    <LeadDialog
                        open={isOpenDialog?.followup}
                        handleClose={() => setOpenDialog({...isOpenDialog, followup: false})}
                        title={handleValidateCodevalue(internationalise,"LEAD_EDIT_FOLLOW_UP")}
                        size="sm"
                        btnlabel={handleValidateCodevalue(internationalise,'COMMON_SAVE')}
                        handleSave={handleSaveFollowUp}
                    >
                        {FollowUpForm}
                    </LeadDialog>
                )}

    <StyledLeadContainer className="edit-lead-poc-row">
            {isMobile &&
                <Stack 
                    className='icon-Container'
                    padding = {isMobile ? "0px 0px": "0px 16px"}
                    bgcolor={"#F4F9FE"}
                    display="flex" 
                    gap = {1}
                    justifyContent="flex-start"
                    flexDirection="row" 
                >
          <Tooltip title={handleValidateCodevalue(internationalise, "COMMON_ADD")}>
                                <IconButton
                                 onClick={() => setOpenDialog({
                        ...isOpenDialog,
                            followup: true
                    })}
                                 >
                                <AddBoxIcon className='followup-icons'
                                />
                                </IconButton>
                            </Tooltip> 
                </Stack>
                }
                <Stack 
                className='icon-Container'
                padding = {isMobile ? "0px 0px": "0px 16px"}
                bgcolor={"#F4F9FE"}
                display="flex" 
                gap = {1}
                justifyContent="flex-start"
                flexDirection="row" 
            >
       <Tooltip title={handleValidateCodevalue(internationalise, "COMMON_SEND_NOTI_EMAIL")}>
                            <IconButton
                             onClick={() => handleOpenNotificationPopup(false,"TEMPLATE_CHANNEL_EMAIL")}
                             >
                            <MarkunreadIcon className='followup-icons'
                            />
                            </IconButton>
                        </Tooltip>          
                        <Tooltip title={handleValidateCodevalue(internationalise, "COMMON_SEND_WHATSAPP")}>
                            <IconButton
                             onClick={()=>handleOpenNotificationPopup(true,"TEMPLATE_CHANNEL_WHATSAPP")}
                             >
                            <WhatsAppIcon className='whatsapp-icon'
                            />
                            </IconButton>
                            </Tooltip>
                        <Tooltip title={handleValidateCodevalue(internationalise, "COMMON_CALL")}>
                            <IconButton
                             onClick={() => {
                                if (isMobile && currentLeadDetail?.phone) {
                                  window.location.href = `tel:${currentLeadDetail.phone}`;
                                  return;
                                }
                                if (telecallingDetails?.accountSid) {
                                  const result = startOutgoingCall({
                                    ClientId: currentUser?.client?.id,
                                    userId: currentUser?.userId,
                                    LeadId: leadId,
                                    phone: currentLeadDetail?.phone,
                                    title: handleValidateCodevalue(internationalise, "COMMON_NOTIFY_LEAD"),
                                  });
                                  if (result?.blocked) {
                                    enqueueSnackbar(handleValidateCodevalue(internationalise, "TC_CALL_ALREADY_ACTIVE") || "A call is already in progress", { variant: "warning" });
                                  }
                                } else if (currentLeadDetail?.phone) {
                                  window.location.href = `tel:${currentLeadDetail.phone}`;
                                }
                              }}
                             >
                            <CallIcon className='followup-icons'
                            />
                            </IconButton>
                        </Tooltip>
                            </Stack>
                                            <Stack 
                                            className='icon-Container'
                                            padding = {isMobile ? "0px 0px": "0px 16px"}
                                            bgcolor={"#F4F9FE"}
                                            display="flex" 
                                            justifyContent="flex-end"
                                            flexDirection="row" 
                                        >
                            <Tooltip title={handleValidateCodevalue(internationalise, "NOTIFY_TOOLTIP_TITLE")}>
                                <IconButton
                                onClick={handleOpenNotifyBox}
                                className='followup-icons'
                            >
                            <NotificationsIcon/>
                            </IconButton>
                            </Tooltip>
                            </Stack>
                            </StyledLeadContainer>
                    </StyledLeadContainer>
                    }    
                {/* </LeadAccordion> */}
                
                    {leadFollowUpData.length > 0 &&
                        <DataGridTable 
                        isCheckboxReq={false}
                        isLead = {true}

                        rowsToView={ROWS_TO_VIEW_IN_CHILD_TABLE}
                        height = {CHILD_DATAGRIDTABLE_HEIGHT}
                        renderValuesOnCard={renderValuesOnCard}
                            handleOnClickCard = {handleCardClick}
                            showId = {false}
                            columns = {followupColumn}
                            dataGridData = {leadFollowUpData}
                        />
                    }
                    {isOpenFollowupPopup.open && (
                        <TextDetailDialog
                            open={isOpenFollowupPopup.open}
                            onClose={() => setIsOpenFollowupPopup({ open: false, selectedCard: null })}
                            title={handleValidateCodevalue(internationalise, "LEAD_EDIT_FU_NOTE")}
                            text={isOpenFollowupPopup?.selectedCard?.note}
                        />
                    )}
                </LeadAccordion>
                <LeadProduct
                    isViewMode = {isViewMode}
                    productTypes={productStaticType}
                    isEdit={true}
                    getProductDetails = {()=>getLeadProductDetails(leadId)}
                    data={leadproduct}
                    leadId={leadId}
                    selectedproductData={selectedproductData}
                    selectedproduct={selectedproduct}
                    selectedaddedproduct={selectedaddedproduct}
                    productQuantity={productQuantity}
                    handleChangeQuantity={handleChangeQuantity}
                    getDataGridData={(data) => setTableData(data)}
                    handleAddLeadProduct={handleAddLeadProduct}
                    handleUpdateLeadproduct={handleUpdateLeadproduct}
                    handleSelectMultiproduct={handleSelectMultiproduct}
                    handleFilterOption={handleFilterOption}
                    inputprice={inputprice}
                    handlechangeInputprice={handlechangeInputprice}
                    pricerange={pricerange}
                    accordionLabel = {handleValidateCodevalue(internationalise,'LEAD_INTERESTED_IN_PRODUCTS')}
                    showRecommendations={true}
                    recommendationButtonLabel={handleValidateCodevalue(internationalise, 'LEAD_PROD_RECC')}
                    recommendationDialogTitle={handleValidateCodevalue(internationalise, 'LEAD_PROD_RECC_TITLE')}
                    fetchRecommendationsUrl={`${process.env.REACT_APP_BASE_URL}lead-product-recommendations/${leadId}`}
                    onRecommendationSecondaryAction={handleAddRecommendedProduct}
                    showSourceProducts={false}
                    showRecommendationToggle={false}
                    recommendationInfoText="LEAD_PROD_RECC_INFO"
                />

                <DocumentManagement
                entityType='leadId'
                url = {`${process.env.REACT_APP_BASE_URL}leadDocument`}
                docType={docType}
                isViewMode={isViewMode}
                clientId = {leadId}
                onSuccess={() => setIsAuditAccordionExpanded(false)}
                />

                {(specificRolePermission?.isAuditView && !isMobile) && <div>
                    <LeadAccordion
                        label={handleValidateCodevalue(internationalise,'COMMON_AUDIT_LOGS')}
                        {...auditAccordion.accordionProps}
                    >
                        <AuditLogs
                            label = ""
                            isSearchRequired = {false}
                            entityDetails = {{
                                entityId: leadId,
                                entity: "LEAD_SIDEBAR_MENU"
                            }}
                            module="Lead"
                        />
                    </LeadAccordion>
                    
                </div>}
            </Box>
            <CreateLeadFooter>
                <Stack alignItems="center" display={"flex"} flexWrap={isMobile ? "nowrap" : "wrap"} gap={isMobile ? "0px" : "5px"} justifyContent={"space-between"} flexDirection="row">
                    <Typography variant='h6'>
                        {`${handleValidateCodevalue(internationalise, 'LEAD_EDIT_TITLE_EDIT')} - ${leadId}`}
                    </Typography>
                    {isMobile &&
                       <>
                       <Button 
                               className="edit-primary btn-space"
                               variant="outlined"
                               onClick={goBack}
                           >
                               <ArrowBackIcon />
                           </Button>
                           <Button
                               className="edit-primary"
                               variant="outlined"
                               onClick={handleUpdateLaed}
                           >
                               <CheckIcon />
                           </Button>
                           </>
                           }   
                    {!isMobile &&
                    <>
                    <Button className='edit-primary btn-space' variant="outlined" onClick={goBack}>{handleValidateCodevalue(internationalise,"COMMON_BACK")}</Button>
                    {/* {((specificRolePermission?.isLeadManage  && showButton) && isViewMode ) &&  <Box><Button className='edit-primary' variant="outlined" onClick={()=>setIsViewMode(!isViewMode)}>{handleValidateCodevalue(internationalise,"COMMON_EDIT")} </Button></Box>} */}
                </>}
                
                </Stack>
                {!isMobile &&
                    <Stack>
                        {specificRolePermission?.isLeadManage &&
                        <StyledFlexEnd>
                            {isDemoMode && (
                                <>
                                <Tooltip title="Assist">
                                <Button className='secondry-edit-btn btn-space' variant="outlined" onClick={() => setIsOpenGuideDialog(true)}>Assist (AI)</Button>
                                </Tooltip>
                                </>
                            )}
                            <Tooltip title={handleValidateCodevalue(internationalise,"LEAD_CREATE_COPY_LEAD")}>
                            <Button className='secondry-edit-btn' variant="outlined" onClick={handleCopyCreateLead}>{handleValidateCodevalue(internationalise,"LEAD_CREATE_COPY_LEAD")}</Button>
                            </Tooltip>
                        </StyledFlexEnd>
                        }
                    </Stack>
                }
            </CreateLeadFooter>
            
                          {
                            (isOpenNotificationDialog?.isOpen) && (
                                <SendNotification
                                    open={isOpenNotificationDialog?.isOpen}
                                    title= {handleValidateCodevalue(internationalise,"COMMON_NOTIFY_LEAD")}
                                    selectedDetails={isOpenNotificationDialog?.selectedDetails}
                                    setIsOpenNotificationDialog = {setIsOpenNotificationDialog}
                                    disableSubject = {false}
                                    autoFillSubjectFromTemplate={true}
                                    type = {"Lead"}
                                    entityType = {"Lead"}
                                    toEmailId={currentLeadDetail?.email}
                                    handleSuccess={handleEmailSent}
                                    entityId={leadId} 
                                    isWhatsapp= {isOpenNotificationDialog?.isWhatsapp}
                                    channel={isOpenNotificationDialog?.channel} 
                                    whatsappNumber={currentLeadDetail?.phone}
                                    phoneCountryCode = {currentLeadDetail?.phoneCountryCode}
                                
                                />
                            )
                        }
                        {
                            isOpenScoreDialog && (
                                <LeadDialog
                                    open={isOpenScoreDialog}
                                    handleClose={() => setIsOpenScoreDialog(false)}
                                    title={handleValidateCodevalue(internationalise,"LP_AI_TITLE")}
                                    size="lg"
                                    btnlabel="Close"
                                    handleSave={() => setIsOpenScoreDialog(false)}
                                >
                                    <ViewLeadSuccessScore leadId={leadId} />
                                </LeadDialog>
                            )
                        }
                        {
                            isOpenGuideDialog && (
                                <LeadDialog
                                    open={isOpenGuideDialog}
                                    handleClose={() => setIsOpenGuideDialog(false)}
                                    title="Lead Summary Guide"
                                    size="lg"
                                    btnlabel="Close"
                                    handleSave={() => setIsOpenGuideDialog(false)}
                                >
                                    <ViewLeadSummary leadId={leadId} />
                                </LeadDialog>
                            )
                        }
                        {openNotifyBox?.open &&
                            <NotificationDialog
                                open={openNotifyBox.open}
                                ownerName={openNotifyBox.ownerName}
                                destinationType="LEAD"
                                contextPayload={{
                                destinationId: openNotifyBox.destinationId,
                                receiverId: openNotifyBox.receiverId,
                                  }}
                                onClose={handleCloseDialog}
                                enqueueSnackbar={enqueueSnackbar}
                                internationalise={internationalise}
                                handleValidateCodevalue={handleValidateCodevalue}
                            />
                        }

            {
                isOpenDialog.dialog && (
                    <LeadDialog 
                        checked = {isOpenDialog?.checked}
                        open = {isOpenDialog?.dialog}
                        handleClose = {() => setOpenDialog({...initialState})}
                        title= {handleValidateCodevalue(internationalise,"LEAD_DC_DIALOG_TITLE")}
                        size="xl"
                        selectionModel={selectionModel}
                        btnlabel={handleValidateCodevalue(internationalise,"LEAD_DC_BUTTON")}
                        alternateBtnLabel = {handleValidateCodevalue(internationalise,"COMMON_CANCEL")}
                        handleSave={() => setConfirmDealClosed(true)}
                    >

                        <Typography gutterBottom>
                          {handleValidateCodevalue(internationalise,"LEAD_DC_DIALOG_TEXT")}
                        </Typography>
                        <Box className = "column-styled-container">
                    {(specificRolePermission?.isCustomerView && !currentLeadDetail?.customerId) &&
                        <FormControlLabel
                        control={<Checkbox
                          checked={isOpenDialog?.customerChecked}
                          onChange={()=>
                            setOpenDialog({
                            ...isOpenDialog,
                            customerChecked : !isOpenDialog?.customerChecked
                        })}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />}
                        label = {handleValidateCodevalue(internationalise,"LEAD_CREATE_CUSTOMER_CHECK")}
                        />
                    }
                    {specificRolePermission?.isOrderView &&
                        <FormControlLabel
                        control={<Checkbox
                          checked={isOpenDialog?.checked}
                          disabled = {!isOpenDialog?.customerChecked && !currentLeadDetail?.customerId}
                          onChange={()=>
                            setOpenDialog({
                            ...isOpenDialog,
                            checked : !isOpenDialog?.checked
                        })}
                          inputProps={{ 'aria-label': 'controlled' }}
                        />}
                        label = {handleValidateCodevalue(internationalise,"LEAD_CREATE_SO_CHECK")}
                        />
                    }
                    </Box>
                        <DataGridTable 
                            showId = {false}
                            showName = "name" 
                            renderValuesOnCard={renderValuesOnCardOfProduct}
                            hideFooter={true}
                            height="calc(70vh - 218px)"
                            isRowSelectable={() => !!isOpenDialog?.checked}
                            columns ={productTableColumn}
                            dataGridData = {dialogProductData}
                            isLoading={isLoading}
                            isRequiredToolBar = {false}
                            isCheckboxReq = {true}
                            setSelectionModel={(newSelectionModel) => setSelectionModel(newSelectionModel)}

                        />
                <StyledLeadContainer className="edit-lead-totals-header-row">
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                       {handleValidateCodevalue(internationalise,'COMMON_SUB_TOTAL')}
                    </Typography>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                        ₹{subTotal.toLocaleString('en-IN')}
                    </Typography>
                </StyledLeadContainer>
                <StyledLeadContainer>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                       {handleValidateCodevalue(internationalise,'COMMON_TOTAL_DISCOUNT')}
                    </Typography>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                        ₹{discountAmount.toLocaleString('en-IN')}
                    </Typography>
                </StyledLeadContainer>
                <StyledLeadContainer>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                       {handleValidateCodevalue(internationalise,'COMMON_PRICE_POST_DISCOUNT')}
                    </Typography>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                        ₹{priceAfterDiscount.toLocaleString('en-IN')}
                    </Typography>
                </StyledLeadContainer>
                <StyledLeadContainer>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                       {handleValidateCodevalue(internationalise,'COMMON_CGST')}
                    </Typography>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                        ₹{cGstAmount.toLocaleString('en-IN')}
                    </Typography>
                </StyledLeadContainer>
                <StyledLeadContainer>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                       {handleValidateCodevalue(internationalise,'COMMON_SGST')}
                    </Typography>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                        ₹{sGstAmount.toLocaleString('en-IN')}
                    </Typography>
                </StyledLeadContainer>
                <StyledLeadContainer>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                       {handleValidateCodevalue(internationalise,'COMMON_TOTAL_GST')}
                    </Typography>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                        ₹{totalGst.toLocaleString('en-IN')}
                    </Typography>
                </StyledLeadContainer>
                <StyledLeadContainer>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                       {handleValidateCodevalue(internationalise,'COMMON_TOTAL_SURCHARGE')}
                    </Typography>
                    <Typography variant="subtitle1" className="edit-lead-total-label">
                        ₹{surchargeAmount.toLocaleString('en-IN')}
                    </Typography>
                </StyledLeadContainer>
                <StyledLeadContainer>
                    <Typography variant="subtitle1" className="edit-lead-grand-total">
                       {handleValidateCodevalue(internationalise,'COMMON_GRAND_TOTAL')}
                    </Typography>
                    <Typography variant="subtitle1" className="edit-lead-grand-total">
                        ₹{finalPrice.toLocaleString('en-IN')}
                    </Typography>
                </StyledLeadContainer>
                    </LeadDialog>
                )
            }
            {
                isDealCloseConfirm && (
                    <LeadDialog 
                        open = {isDealCloseConfirm}
                        handleClose = {() => setConfirmDealClosed(false)}
                        handleSave={ handleDealClose}
                        title= {handleValidateCodevalue(internationalise,"LEAD_FINAL_DC_TITLE")}
                        size="sm"
                        selectionModel={selectionModel}
                        btnlabel="Yes"
                        selectedowner={true}
                        alternateBtnLabel="Cancel"
                    >
                        <Typography gutterBottom>
                          {handleValidateCodevalue(internationalise,"LEAD_FINAL_DC_DESC")}
                          </Typography>

                
                    </LeadDialog>
                )
            }
        </React.Fragment>
        </BiztantuLoader>
    )
}



export default EditLead;

